<div class="d-flex">
    <div class="mr-3">
            <img src="{{ captchaImageBase64 }}" alt="" />
    </div>
    <div class="w-100">
        <input [(ngModel)]="captchaValue" (input)="codeChanged($event.target.value)" [maxLength]="maxLength" type="text" class="form-control"
            placeholder="اكتب الرمز">
    </div>
</div>
